import type { Meter } from '../calculator/types';

/**
 * How many stepper steps to show for each meter.
 *
 * `csResolutions` skips the allowance step entirely, so users only ever see
 * three steps: Usage type → Usage needs → Estimate. All other meters flow
 * through all five steps but the stepper on the first two steps (usage +
 * needs) only previews the first three to avoid confusing users who haven't
 * yet committed to a full journey.
 */
export const METER_STEPPER_COUNT: Record<Meter, number> = {
	assetsObjects: 5,
	automations: 5,
	rovoCredits: 5,
	// AI agent resolutions has no allowance step — show only 3 steps throughout.
	csResolutions: 3,
};
